import React from 'react'
import { TbViewProvider } from '@vt/hooks'
import { useParams } from 'react-router-dom'
import { getQuery } from '@vt/utils'
import Content from './content'

const Area = () => {
  const { appId } = useParams()
  const { vid } = getQuery()

  return (
    <TbViewProvider appId={appId} tbId="area" vid={vid}>
      <Content type="area" />
    </TbViewProvider>
  )
}

export default Area
